<template>
  <div>
    <el-dialog
      title="合服进度"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="440px"
    >
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in form.processes"
          :key="index"
          :color="item.color"
          :icon="item.icon"
          :timestamp="item.at"
        >
          {{ item.content }}
        </el-timeline-item>
      </el-timeline>

      <div v-if="this.form.status == 1">
        <el-button
          style="margin-top: 10px; margin-left: 110px"
          type="primary"
          icon="el-icon-circle-check"
          @click="confirm()"
          >确认完成合服</el-button
        >
        <p v-if="!$bizutil.isCloudNative()" style="margin-top: 10px; margin-left: 70px; color: red">
          确认之前请务必确保被合的服已经停服!
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "MergeZonesProcessDialog";

export default {
  data() {
    return {
      form: {},
      taskId: 0,
      intervalEntry: null,
    };
  },

  async created() {
    this.form = this.$dialogutil.getData(DialogName).entry;
    this.taskId = this.form.id;
    this.intervalEntry = setInterval(async () => {
      if (!this.form.status > 0) {
        this.form = await this.refresh(this.taskId);
      }
    }, 1000);
  },

  methods: {
    async confirm() {
      try {
        await this.$confirm(`确认完成范围[${this.form.zoneRange}]合服`, {
          type: "warning",
        });
        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/confirmFinishZoneMergeTask`,
            { id: this.form.id },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        this.onClose();
      } catch (e) {}
    },
    async refresh(id) {
      let entry = null;
      try {
        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/queryZoneMergeTasks`,
            {
              id: id,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        let listInResponse = resData.data.list || [];
        if (listInResponse.length > 0) {
          entry = listInResponse[0];
        }
      } catch (e) {}

      return entry;
    },

    parseTimeStr(val) {
      let timeStr = "";
      let sec = val % 60;
      timeStr = (sec < 10 ? "0" + sec : sec) + "";

      val = parseInt(val / 60);
      let minute = 0;
      if (val > 0) {
        minute = val % 60;
      }
      timeStr = (minute < 10 ? "0" + minute : minute) + ":" + timeStr;

      // val = parseInt(val / 60);
      // let hour = 0;
      // if (val > 0) {
      //   hour = val % 60;
      // }
      // timeStr = (hour < 10 ? "0" + hour : hour) + ":" + timeStr;

      return timeStr;
    },

    onClose() {
      clearInterval(this.intervalEntry);
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>
